"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographyVariants = void 0;
exports.TypographyVariants = {
    display: {
        fontSize: "font-size-12",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-none",
        lineHeight: "leading-1"
    },
    "display-light": {
        fontSize: "font-size-12",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-none",
        lineHeight: "leading-1"
    },
    h1: {
        fontSize: "font-size-11",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h1-light": {
        fontSize: "font-size-11",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    h2: {
        fontSize: "font-size-10",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h2-light": {
        fontSize: "font-size-10",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    h3: {
        fontSize: "font-size-9",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h3-light": {
        fontSize: "font-size-9",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    h4: {
        fontSize: "font-size-8",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h4-light": {
        fontSize: "font-size-8",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    h5: {
        fontSize: "font-size-7",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h5-light": {
        fontSize: "font-size-7",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    h6: {
        fontSize: "font-size-6",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h6-light": {
        fontSize: "font-size-6",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "title-1-medium": {
        fontSize: "font-size-5",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-1",
        lineHeight: "leading-2"
    },
    "title-1-regular": {
        fontSize: "font-size-5",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-1",
        lineHeight: "leading-2"
    },
    "title-2-medium": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-1",
        lineHeight: "leading-2"
    },
    "title-2-regular": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-1",
        lineHeight: "leading-2"
    },
    "body-1-bold": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-bold",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "body-1-medium": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "body-1-regular": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "body-2-bold": {
        fontSize: "font-size-3",
        fontWeight: "font-weight-bold",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "body-2-medium": {
        fontSize: "font-size-3",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "body-2-regular": {
        fontSize: "font-size-3",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "button-xlarge": {
        fontSize: "font-size-5",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-none",
        lineHeight: "leading-1"
    },
    "button-large": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-none",
        lineHeight: "leading-1"
    },
    "button-base": {
        fontSize: "font-size-3",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-none",
        lineHeight: "leading-1"
    },
    "caption-bold": {
        fontSize: "font-size-2",
        fontWeight: "font-weight-bold",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    caption: {
        fontSize: "font-size-2",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    overline: {
        fontSize: "font-size-2",
        fontWeight: "font-weight-bold",
        letterSpacing: "kerning-4",
        lineHeight: "leading-2"
    },
    "microtype-bold": {
        fontSize: "font-size-1",
        fontWeight: "font-weight-bold",
        letterSpacing: "kerning-2",
        lineHeight: "leading-2"
    },
    microtype: {
        fontSize: "font-size-1",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-2",
        lineHeight: "leading-2"
    }
};
//# sourceMappingURL=TypographyVariants.js.map